/*
 * Copyright (c) 2024. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

/**
 * `true` when running inside a Tauri WebView (desktop or iOS shell). Detected
 * by the `__TAURI_INTERNALS__` global Tauri injects into every webview before
 * any app code runs.
 */
export const IS_TAURI = '__TAURI_INTERNALS__' in globalThis
